import { BBC_AGING_REPORT } from '@common/interfaces/bbc'
import { IRootState } from '../reducer'
import { prefix } from './actions'

export const isLoading = (state: IRootState) => state[prefix].loadingArray.length > 0

export const bbc = (state: IRootState) => state[prefix].bbc

const clientCollateralFreshness = (state: IRootState) => state[prefix].clientCollateralFreshness

/** The eligibility revision a calculation started now would read. */
export const clientCollateralRevision = (state: IRootState) =>
  clientCollateralFreshness(state).revision

/** An eligibility save landed after the newest calculation read its inputs. */
export const isClientCollateralStale = (state: IRootState) => {
  const { revision, calculatedRevision } = clientCollateralFreshness(state)
  return revision > calculatedRevision
}

export const inventoryIneligibilityData = (state: IRootState) =>
  state[prefix].inventoryIneligibilityData

export const fields = (state: IRootState) => state[prefix].fields

export const clientCollaterals = (state: IRootState) => state[prefix].clientCollaterals

export const previousClientCollateralsMap = (state: IRootState) =>
  state[prefix].previousClientCollaterals

export const previousClientCollateralsFor =
  (agingReport: BBC_AGING_REPORT) => (state: IRootState) =>
    state[prefix].previousClientCollaterals[agingReport]

// `arapChartData` is keyed by `BBC_AGING_REPORT` (see redux/bbc/reducer.ts) so
// the concurrently-mounted AR and AP charts on Amendment Analysis' Collateral
// Overview don't race for one shared slot. `arapChartDataFor` is for
// consumers that always want one fixed report (e.g. the AR-only/AP-only BBC
// summary tables). `arapChartDataMap` returns the whole keyed record for
// consumers whose `agingReport` is a dynamic prop rather than a redux
// dependency — they pick their own bucket from it.
export const arapChartDataFor = (agingReport: BBC_AGING_REPORT) => (state: IRootState) =>
  state[prefix].arapChartData[agingReport]

export const arapChartDataMap = (state: IRootState) => state[prefix].arapChartData

export const arapChartDataDropdownOptionsFor =
  (agingReport: BBC_AGING_REPORT) => (state: IRootState) =>
    state[prefix].arapChartDataDropdownOptions[agingReport]

export const arRollforward = (state: IRootState) => state[prefix].arRollforward

export const arRollforwardGraph = (state: IRootState) => state[prefix].arRollforwardGraph

export const apRollforward = (state: IRootState) => state[prefix].apRollforward

export const reserves = (state: IRootState) => state[prefix].reserves

export const customRules = (state: IRootState) => state[prefix].customRules

export const customRulesLabels = (state: IRootState) => state[prefix].customRulesLabels

export const customRulesValues = (state: IRootState) => state[prefix].customRulesValues

export const inventoryIneligibleStats = (state: IRootState) =>
  state[prefix].inventoryIneligibleStats

export const arIneligibleStats = (state: IRootState) => state[prefix].arIneligibleStats

export const ineligibleInvoices = (state: IRootState) => state[prefix].ineligibleInvoices

export const arSummaryStats = (state: IRootState) => state[prefix].arSummaryStats

export const apSummaryStats = (state: IRootState) => state[prefix].apSummaryStats

export const apReserves = (state: IRootState) => state[prefix].apReserves

export const arIneligibilityData = (state: IRootState) => state[prefix].arIneligibilityData

export const masterInvoicesBbcData = (state: IRootState) => state[prefix].masterInvoicesBbcData

export const inventoryDistributionData = (state: IRootState) =>
  state[prefix].inventoryDistributionData

export const inventoryDistributionCategories = (state: IRootState) =>
  state[prefix].inventoryDistributionCategories

export const inventoryAgingDistribution = (state: IRootState) =>
  state[prefix].inventoryAgingDistribution

export const foreignCountryDropdown = (state: IRootState) => state[prefix].foreignCountryDropdown
